import type {RouteLocationNormalizedLoaded} from 'vue-router'

export async function useActivityRuntimeData(route: RouteLocationNormalizedLoaded) {
    const searchRequest = activitiesRuntimeStore.searchRequestFromQuery(route.query)

    if (searchRequest.cityId && activitiesRuntimeStore.city.id !== searchRequest.cityId) {
        await activitiesRuntimeStore.loadCity(searchRequest.cityId)
    } else if (searchRequest.countryId && activitiesRuntimeStore.country.id !== searchRequest.countryId) {
        await activitiesRuntimeStore.loadCountry(searchRequest.countryId)
    }
}
